import types from './constants'

export default {
  [types.DIAGNOSTIC_PENDING]: () => ({
   type: types.DIAGNOSTIC_PENDING,
  }),
  [types.DIAGNOSTIC_COMPLETE]: (report) => ({
   type: types.DIAGNOSTIC_COMPLETE,
   report
  }),
  [types.DIAGNOSTIC_ERROR]: (error) => ({
   type: types.DIAGNOSTIC_ERROR,
   error
  }),
}